import { Flex } from '@utilitywarehouse/hearth-react';
import { useNavigate } from 'react-router-dom';

import { paths } from '@constants/paths';
import { AppointmentParticipantType } from '@generated/gql/graphql';
import { useAppointmentContext } from '@providers/AppointmentProvider/AppointmentContext';

import { LobbyDetails } from './Details';
import { LobbyList } from './List';
import './styles.scss';

const Lobby = () => {
  const {
    appointment,
    session,
    hasCustomer,
    isRemoteSupport,
    awaitingRemoteSupport,
  } = useAppointmentContext();
  const navigate = useNavigate();

  if (!appointment || !session?.userId) return null;

  // customer will not be a participant for F2F + Remote support
  const canStart = !isRemoteSupport ? hasCustomer : true;

  const handleStart = () => {
    if (!canStart) {
      return;
    }
    navigate(paths.presentation);
  };

  return (
    <Flex direction={{ mobile: 'column', tablet: 'row' }} spacing="xl">
      <LobbyList
        participants={appointment.participants}
        userId={session.userId}
        onStart={handleStart}
        isRemoteSupport={isRemoteSupport}
        isSupported={awaitingRemoteSupport}
        canStart={canStart}
      />
      {session.userType !== AppointmentParticipantType.Customer && (
        <LobbyDetails code={appointment.id} />
      )}
    </Flex>
  );
};

export { Lobby };
